<div class="container">
  <mat-form-field class="recipe-search-bar input-recipe-search-bar" appearance="fill" subscriptSizing="dynamic">
    <mat-chip-grid #chipGrid>
      <input
        id="RecipesSearchSearchTxt"
        #searchInput
        matInput
        type="text"
        [matChipInputFor]="chipGrid"
        [matAutocomplete]="auto"
        [formControl]="searchControl"
        (keyup.enter)="emitSearchBarChange()"
        placeholder="{{ 'SEARCH_PLACEHOLDER' | translate }}"
      />
      <mat-chip-row class="mat-chip" *ngFor="let item of selectedItems" (removed)="remove(item.value)">
        {{ item.type }}: {{ item.value }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>

      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChanged($event)">
        <ng-container *ngIf="filteredOptions | async; let options">
          <mat-optgroup label="{{ 'RECIPE_ACP.RECIPES' | translate }}" *ngIf="options?.recipe?.values?.length">
            <mat-option *ngFor="let recipe of options?.recipe?.values" [value]="{ data: recipe, field: 'recipe' }">
              {{ recipe }}
            </mat-option>
          </mat-optgroup>
          <mat-optgroup label="{{ 'RECIPE_ACP.INGREDIENTS' | translate }}" *ngIf="options?.ingredient?.values?.length">
            <mat-option *ngFor="let ingredient of options?.ingredient?.values" [value]="{ data: ingredient, field: 'ingredient' }">
              {{ ingredient }}
            </mat-option>
          </mat-optgroup>
        </ng-container>
      </mat-autocomplete>
    </mat-chip-grid>
  </mat-form-field>
  <button mat-fab extended class="btn-acp" id="RecipeSearchSearchBtn" (click)="search()">
    <mat-icon>search</mat-icon>
    {{ 'APPLICATIONS.SEARCH' | translate }}
  </button>
</div>
